import { type MouseEvent, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from '../../../styled-system/css';
import { useAuth } from '../../auth/hooks/useAuth';
import { Profile } from '../../icons/Profile';
import { Button } from '../../ui/form/buttons/button/component/Button';

interface MenuProps {
  onClose: () => void;
}

const Menu = ({ onClose }: MenuProps) => {
  const navigate = useNavigate();

  const handleSignOut = useCallback(() => {
    navigate('/logout');
    onClose();
  }, [navigate, onClose]);

  useEffect(() => {
    window.addEventListener('click', onClose);

    return () => {
      window.removeEventListener('click', onClose);
    };
  }, [onClose]);

  const handleCaptureClick = useCallback((e: MouseEvent<HTMLUListElement>) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <ul
      className={css({
        backgroundColor: 'flyOutMenuBg',
        // @ts-expect-error Ignore this for now
        border: '[1px] [solid] token(colors.flyOutMenuBorder)',
        borderRadius: 'sm',
        boxShadow: 'md',
        position: 'absolute',
        right: '4',
        width: '52',
      })}
      onClick={handleCaptureClick}
    >
      <li>
        <Button use="transparent" onClick={handleSignOut}>
          Sign out
        </Button>
      </li>
    </ul>
  );
};

export const ProfileMenu = () => {
  const navigate = useNavigate();
  const { uid } = useAuth();

  const [menuOpen, setMenuOpen] = useState(false);

  const handleClick = useCallback(
    (e?: MouseEvent<HTMLButtonElement>) => {
      e?.preventDefault();
      e?.stopPropagation();

      if (uid) {
        setMenuOpen((old) => !old);
      } else {
        navigate('/login');
      }
    },
    [navigate, uid]
  );

  const handleClose = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <div>
      <Button use="transparent" onClick={handleClick}>
        <Profile />
      </Button>
      {menuOpen && <Menu onClose={handleClose} />}
    </div>
  );
};
